import * as React from "react";
import SecondaryMenu from "../shared/SecondaryMenu";
import { LinearProgress, Tab, Tabs } from "@material-ui/core";
import useStyles from "./styles";
import RepricingTool from "./RepricingTool";
import ErrorLog from "./ErrorLog";

const TabPanel = (props: any) => {
  const { children, value, selected } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== selected}
      id={`billing-tabpanel-${value}`}
    >
      {value === selected && children}
    </div>
  );
};

const a11yProps = (value: number) => {
  return {
    value,
    id: `billing-tab-${value}`,
    disableRipple: true,
  };
};

const ViewBillingWidget = (): JSX.Element => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = React.useState(1);
  const [loading, setLoading] = React.useState(false);

  const handleTabChange = (event: any, newValue: number) => {
    setSelectedTab(newValue);
  };

  const CreateLoadingLine = (props: any): JSX.Element => {
    return (
      <div className={classes.loading}>
        <LinearProgress color="primary" />
      </div>
    );
  };
  
  return (
    <div style={{ display: "flex", alignItems: "stretch", flexGrow: 1 }}>
      <div style={{ alignSelf: "stretch", display: "flex" }}>
        <SecondaryMenu selectedmenu="Billing" />
      </div>
      <div
        style={{
          display: "flex",
          alignSelf: "start",
          width: "100%",
          height: "100%",
        }}
      >
        <div className={classes.main}>
          <div className={classes.heading}>Billing</div>
          <div>{loading ? <CreateLoadingLine /> : null}</div>
          <div className={classes.tabsSection}>
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              variant="standard"
            >
              <Tab label={"Repricing Tool"} {...a11yProps(1)} />
              <Tab label={"Error Log"} {...a11yProps(2)} />
            </Tabs>
          </div>
          <TabPanel value={1} selected={selectedTab}>
            <RepricingTool setLoading = {setLoading} />
          </TabPanel>
          <TabPanel value={2} selected={selectedTab}>
            <ErrorLog setLoading = {setLoading}/>
          </TabPanel>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ViewBillingWidget);
